import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import ScenarioSelectionRedefinedWrapperTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText } from '@facet-wealth/design';
import Content from './Content';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['plannerInsightsBody'], {
    _component: () => FDBodyText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly);

const ScenarioSelectionRedefinedTheYearAheadAllocatableResourcesStepTemplate = ({
  resource,
}) => {
  return (
    <ScenarioSelectionRedefinedWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
    />
  );
};

ScenarioSelectionRedefinedTheYearAheadAllocatableResourcesStepTemplate.defaultProps = {
};

ScenarioSelectionRedefinedTheYearAheadAllocatableResourcesStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedTheYearAheadAllocatableResourcesStepTemplate;
